export default "__VITE_ASSET__CkaZPoRa__"